import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { catchError, map, switchMap, tap } from "rxjs/operators";

import { AddressAction } from "./address.action";
import { AddressService } from "./address.service";

@Injectable()
export class AddressEffect {
	getAddresses$: Observable<Action> = createEffect(() =>
		this.actions$.pipe(
			ofType(AddressAction.getAddresses),
			tap(() => {}),
			switchMap(() =>
				this.addressService.getAddresses().pipe(
					map((response) => AddressAction.getAddressesSuccess(response)),
					catchError((error) => of(AddressAction.getAddressesFail(error)))
				)
			)
		)
	);

	constructor(
		private actions$: Actions,
		private addressService: AddressService
	) {}
}
